import React, { Component } from "react";


class Error extends Component {
	constructor() {
		super();
		this.state = {
			error: '',
			errorInfo: '',
		}
	}

	componentDidCatch(error, errorInfo) {
		this.setState({
			error: error,
			errorInfo: errorInfo,
		});
	}

	componentDidMount() {
		window.history.go(-1)
	}

	render() {
		return (
			<div className="error">
				<div>{this.state.error}</div>
				<br />
				<div>{this.state.errorInfo}</div>
			</div>
		)
	}
}

export default Error;